export function buildReportsPageQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Reports.Reports.Queries.ReportsPageQueryV1, TCh.Domain.Reports',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}

export function buildReportQueryV1(workspaceId: number, reportId: string)
{
	return {
		'$type': 'TCh.Domain.Reports.Reports.Queries.ReportQueryV1, TCh.Domain.Reports',
		'WorkspaceId': workspaceId,
		'ReportId': reportId,
	}
}


export function buildPortfolioBalancerReportPageQueryV1(workspaceId: number, projectId: number, reportId: string)
{
	return {
		'$type': 'TCh.Domain.Reports.Reports.Queries.PortfolioBalancerReportPageQueryV1, TCh.Domain.Reports',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ReportId': reportId,
	}
}